import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import ReactPixel from 'react-facebook-pixel';
import paymentSuccess from "../../assets/paymentSuccess.png";
import paymentProcessing from "../../assets/paymentProcessing.png";
import { useDispatch } from "react-redux";
import { FetchTransaction } from "../../redux/actions/PlanAction";
import { getDate, textDott } from "../../helpers/TimeDate";
import Loder from "../loder";
import { useHistory } from "react-router";

const SubscriptionMessageModal = ({ show, handleClose }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [transactions, setTransaction] = useState(null);
  const [showTransaction, setShowTransaction] = useState(false);

  useEffect(() => {
    setTransaction(null)
    const onSuccess = (data) => {
      console.log(data);
      setTransaction(data.transaction);
    };
    const onErr = (msg) => {
      console.log(msg); 
    };
    dispatch(FetchTransaction(onSuccess, onErr));
  }, [show]);

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="text-center subscription_modal">
          {transactions ? (
            <>
              {showTransaction === false ? (
                <>
                  {transactions ? (
                    transactions.length > 0 ? (
                      transactions[0].status === "Success" ? (
                        <>
                          <div className="d-flex justify-content-center">
                            <img
                              src={paymentSuccess}
                              alt="payment success"
                              className="img-fluid"
                            />
                          </div>
                          <h3>Payment done</h3>
                          <p>
                          Your Payment for Subscription is successful. You can check your transactions from your Profile section.
                          </p>
                        </>
                      ) : (
                        <>
                          <div className="d-flex justify-content-center">
                            <img
                              src={paymentProcessing}
                              alt="payment success"
                              className="img-fluid"
                            />
                          </div>
                          <h3>Payment in progress</h3>
                          <p>
                          Your Payment is in progress. You can check your transactions from your Profile section.
                          </p>
                        </>
                      )
                    ) : (
                      ""
                    )
                  ) : (
                    <Loder />
                  )}
                  <button id="yourtransactionid" onClick={() => setShowTransaction(true)}>
                    Your transaction
                  </button>
                </>
              ) : (
                <>
                  <div className="trans ">
                    <div className="profile_modal_content">
                      <h4>Your Transactions</h4>
                      <div>
                        {transactions ? (
                          transactions[0] ? (
                            transactions.map((data, i) => (
                              <div
                                className="card mt-4"
                                style={{ width: "100%" }}
                                key={i}
                              >
                                <div className="d-flex">
                                  <div>
                                    <div>
                                      <p className="top mb-0">Date:</p>
                                      <p className="bottom">
                                        {getDate(data.date)}
                                      </p>
                                    </div>

                                    <div>
                                      <p className="top mb-0">Order id:</p>
                                      <p className="bottom">
                                        {textDott(data.orderid, 15)}
                                      </p>
                                    </div>
                                  </div>
                                  <div>
                                    <div className="text-center">
                                      <div
                                        className={
                                          data.status === "Pending tag mx-auto"
                                            ? "pending"
                                            : data.status === "Failed"
                                            ? "faluare tag mx-auto"
                                            : " tag mx-auto"
                                        }
                                      >
                                        {data.status}
                                      </div>
                                    </div>

                                    <div>
                                      <p className="top mb-0 mt-4 ml-5">
                                        Plan:
                                      </p>
                                      <p className="bottom ml-5">
                                        {data.txndescription}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="text-center">
                              Transaction Histoty not available
                            </div>
                          )
                        ) : (
                          <Loder />
                        )}
                      </div>
                    </div>
                  </div>
                  <button onClick={() => history.push("/dashboard")}>
                    <i className="fas fa-arrow-left"></i> Back
                  </button>
                </>
              )}
            </>
          ) : (
            <>
            <div className="d-flex justify-content-center">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
            <h3 className="text-center">Payment Processing ...</h3>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SubscriptionMessageModal;
